module.exports = __webpack_public_path__ + "img/outline-ia-green.74ae775.svg";